import ListaProjetos from "componentes/ListaProjetos";
import styles from "./Projetos.module.css"
import { motion } from 'framer-motion'

export default function Projetos() {
    return (
        <motion.div
            initial={{ opacity: 0, y:10 }}
            animate={{ opacity: 1, y:0 }}
            className={styles.lista}>
            <ListaProjetos />
        </motion.div>
    )
}
